export default __webpack_public_path__ + "images/btcIcon_4c1c2e.svg";